import { SerializedStyles, css } from '@emotion/react';
import { Theme } from '@zip/theme';

const horizontalBreak = 675;

export const container =
  (backgroundColor: string, carouselItem: boolean) =>
  (theme: Theme): SerializedStyles =>
    css`
      height: ${carouselItem ? '100%' : 'auto'};
      border: 1px solid ${theme.colors.neutral[200]};
      border-radius: ${theme.radii.lg};
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      position: relative;
      background-color: ${backgroundColor};

      :not(:first-of-type) {
        margin-top: 1.5rem;
      }

      &:hover {
        cursor: pointer;
      }
    `;

export const content = css`
  padding: 1.5rem;
  min-width: 320px;
  position: relative;
  z-index: 1;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${horizontalBreak}px) {
    min-width: 60%;
  }
`;

export const textButtonCopy = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const imageContainer = (
  backgroundColor: string,
  imgAlign: string = 'center'
): SerializedStyles => css`
  position: relative;
  min-width: 35%;

  display: flex;
  align-items: ${imgAlign};

  ::before {
    content: ' ';
    position: absolute;
    right: -1.25rem;
    width: 100%;
    height: 100%;
    background-color: ${backgroundColor};
    transform: skew(10deg);
  }
`;

export const image = (
  imgPadding: string = '0',
  mobileImgMargin: string = 'inherit',
  fullImage: boolean = false
): SerializedStyles => css`
  z-index: 3;
  position: absolute;
  left: 10%;
  right: 10%;
  margin: 0 auto;
  padding: ${imgPadding};
  height: 100%;
  max-width: calc(100% - calc(2 * ${imgPadding}));
  width: ${fullImage ? '100%' : 'inherit'};
  object-fit: ${fullImage ? 'cover' : 'inherit'};
  transform: ${fullImage ? 'skew(10deg)' : 'none'};

  @media screen and (max-width: ${horizontalBreak}px) {
    position: static;
    margin: ${mobileImgMargin};
    height: ${fullImage ? '100%' : '75%'};
    width: ${fullImage ? '120%' : 'inherit'};
  }
`;
